import { useNavigate } from "@tanstack/react-router";
import Box from "@mui/material/Box";
import { DataTable } from "../../components/DataTable";
import { PostponeEntitlementDialog } from "./PostponeEntitlementDialog";

const columns = [
  { accessorKey: "name", header: "Name", meta: { minWidth: 150 } },
  { accessorKey: "yourid", header: "Wearer ID", meta: { minWidth: 150 } },
  { accessorKey: "gender", header: "Gender", meta: { minWidth: 100 } },
  { accessorKey: "branchname", header: "Branch", meta: { minWidth: 150 } },
  { accessorKey: "wardrobename", header: "Wardrobe", meta: { minWidth: 200 } },
  { accessorKey: "productsCount", header: "Products", meta: { minWidth: 100 } },
  { accessorKey: "itemsCount", header: "Items", meta: { minWidth: 100 } },
  {
    accessorKey: "disablePostpone",
    header: "Postpone",
    meta: { align: "center" },
    cell: (info) => (
      // The dialog lives inside a clickable row, so swallow the click here.
      <Box onClick={(event) => event.stopPropagation()}>
        <PostponeEntitlementDialog
          disabled={info.getValue() === "true"}
          staffId={info.row.original.staffid}
          staffName={info.row.original.name}
        />
      </Box>
    ),
  },
];

export const EntitlementTable = ({
  data,
  loading,
  filter,
  setFilter,
  type,
}) => {
  const navigate = useNavigate();

  // This endpoint takes no page argument and returns every row at once, so the
  // pager has to work on what is already here.
  const staff = data?.staff || [];
  const rowCount = staff.length;

  const pagination = {
    page: (filter?.page ?? 1) - 1,
    pageSize: filter?.pageSize ?? 25,
  };

  const pageStart = pagination.page * pagination.pageSize;
  const pageRows = staff.slice(pageStart, pageStart + pagination.pageSize);

  const handlePaginationChange = (next) => {
    setFilter((prevState) => ({
      ...prevState,
      page: next.page + 1,
      pageSize: next.pageSize,
    }));
  };

  return (
    <DataTable
      aria-label="Entitlements"
      columns={columns}
      rows={pageRows}
      getRowId={(row) => row.staffid}
      rowCount={rowCount}
      page={pagination.page}
      pageSize={pagination.pageSize}
      loading={loading}
      onPaginationChange={handlePaginationChange}
      onRowClick={(row) =>
        navigate({ to: `/entitlement/${row.staffid}`, search: { type } })
      }
    />
  );
};

// {
//     "staffid": "STA122505",
//     "branchid": "B002",
//     "name": "Dave Piggleston",
//     "gender": "O",
//     "uniform": "WARDROBE00025",
//     "yourid": "0014566678",
//     "branchname": "Branch 2 England",
//     "wardrobename": "Standard Wardrobe",

//     "productsCount": "       15",
//     "itemsCount": "25",

//     "disablePostpone": "true",
//     "postponeDaysCnt": null
// }
